import { render, staticRenderFns } from "./gameOrder.vue?vue&type=template&id=377ca9e1&scoped=true&"
import script from "./gameOrder.vue?vue&type=script&lang=js&"
export * from "./gameOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377ca9e1",
  null
  
)

export default component.exports